module.exports = __webpack_public_path__ + "src/assets/img/customer-logos/doximity.dbba2691b2018fd0ae77a25169098946.png";